import { AuctionNearMeHit } from '@/pages/AuctionsNearMe/types/AuctionsNearMe.types';

export type AuctionsNearMeSlice = {
    hits: AuctionNearMeHit[];
};

export const defaultAuctionsNearMeSlice: AuctionsNearMeSlice = {
    hits: [],
};
